import React from 'react';
type EyebrowTone = 'amber' | 'muted' | 'rose';
interface EyebrowProps {
  children: React.ReactNode;
  tone?: EyebrowTone;
  align?: 'left' | 'center';
}
const toneClasses: Record<EyebrowTone, {
  text: string;
  line: string;
}> = {
  amber: {
    text: 'text-amber',
    line: 'bg-amber'
  },
  muted: {
    text: 'text-cream-muted',
    line: 'bg-cream-muted'
  },
  rose: {
    text: 'text-rose',
    line: 'bg-rose'
  }
};
export function Eyebrow({
  children,
  tone = 'amber',
  align = 'left'
}: EyebrowProps) {
  const colors = toneClasses[tone];
  return <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-87" data-mp="16xb1uttqf87n">
      <span className={`h-px w-8 shrink-0 ${colors.line}`} aria-hidden="true" data-id="element-88" data-mp="sy1ywvujealm" />
      <p className={`text-[10px] font-semibold uppercase tracking-label sm:text-[11px] ${colors.text}`} data-id="element-89" data-mp="xv1u2bpulsxy">
        {children}
      </p>
    </div>;
}